"use strict";
/**
 * 主页面JS
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
window.mainpath = location.pathname.indexOf('/center2/') == 0 ? 'center2' : 'center';
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
require("../css/index.less");
var tophsgt_1 = __importDefault(require("../components/tophsgt"));
react_dom_1.default.render(react_1.default.createElement(tophsgt_1.default, null), document.getElementById('tq_hsgt'));
var qqgs_1 = require("../components/topquote/qqgs");
react_dom_1.default.render(react_1.default.createElement(qqgs_1.QQGS, null), document.getElementById('globalstocks'));
var bhistory_1 = require("../components/history/bhistory");
react_dom_1.default.render(react_1.default.createElement(bhistory_1.BHistory, { size: 6 }), document.getElementById('bhistory'));
// import { QQAdvtisement } from '../components/qiquanadv'
// ReactDOM.render(
//   <QQAdvtisement></QQAdvtisement>,
//   document.getElementById('qq_adv')
// )
var react_router_dom_1 = require("react-router-dom");
var leftnav_1 = require("../components/leftnav");
var mainc_1 = require("../components/mainc");
var head_tzzh_1 = require("../components/head_tzzh");
var routmapping_1 = __importDefault(require("../modules/routmapping"));
var feedback_1 = require("../components/feedback");
/** 页面主区域 */
function MainPage() {
    var map_url = location.href.replace(location.origin, ""); // 获取url origin后面的完整部分
    var map_val = routmapping_1.default[map_url];
    if (map_val) {
        self.location.href = map_val;
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (map_url.match(/\/center\/boardlist\.html/i)) {
        // console.info(111)
        self.location.href = "/center/gridlist.html".concat(location.search).concat(location.hash);
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    //老的板块地址 /center/boardlist.html#boards-BK1108 跳转到新的
    if (map_url.match(/\/center\/gridlist\.html#boards-bk\d+/i)) {
        var bkid = (map_url.match(/\d+/)[0]).toString();
        if (bkid.length == 5 && bkid.substring(4, 5) == '1') {
            bkid = bkid.substring(0, 4);
        }
        self.location.href = "/center/gridlist.html#boards2-90.BK".concat(bkid);
    }
    //老的 /center/list.html#28003500_0_2 板块地址跳转到新的
    if (map_url.match(/\/center\/list\.html#2800(\d)(\d{3})\w/i)) {
        var bkid = (map_url.match(/\/center\/list\.html#2800(\d)(\d{3})\w/i)[2]).toString();
        self.location.href = "/center/gridlist.html#boards2-90.BK0".concat(bkid);
    }
    // 页面不存在404
    // if(location.pathname != ''){
    // }
    (0, react_1.useEffect)(function () {
        if (window.suggest2017) {
            new suggest2017({
                inputid: 'search_box',
                width: 310,
                newapi: true,
                shownewtips: true,
                newtipsoffset: {
                    top: -2,
                    left: 0
                }
            });
        }
    }, []);
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement("div", { id: "leftnav" },
            react_1.default.createElement(leftnav_1.LeftNav, null)),
        react_1.default.createElement("div", { id: "mainc" },
            react_1.default.createElement(feedback_1.FeedBack, null),
            react_1.default.createElement(mainc_1.MainContent, null))));
}
react_dom_1.default.render(react_1.default.createElement(MainPage, null), document.getElementById('mainpage'));
//投资组合
react_dom_1.default.render(react_1.default.createElement(head_tzzh_1.HeadTZZH, null), document.getElementById('zhrool'));
